import { Box, Divider, Typography } from '@mui/material';
import { StatusInfo } from '@features/workspace/components/shared/status-info';
import { useId } from 'react';
import { useAppSelector } from '@store/hooks';
import {
  selectHasCompleteVerification,
  selectHasCompleteContactsDetails,
  selectHasCompletePrimaryContactDetails,
  selectHasCompleteProductSelection,
  selectHasCompleteCompanyDetails,
} from '@features/workspace/store/selectors';

export function CustomerApplicationStatus() {
  const id = useId();

  const hasCompletePrimaryContactDetails = useAppSelector(
    selectHasCompletePrimaryContactDetails
  );
  const hasCompleteVerification = useAppSelector(selectHasCompleteVerification);
  const hasCompleteContactsDetails = useAppSelector(
    selectHasCompleteContactsDetails
  );
  const hasCompleteProductSelection = useAppSelector(
    selectHasCompleteProductSelection
  );
  const hasCompleteCompanyDetails = useAppSelector(
    selectHasCompleteCompanyDetails
  );

  const properties: Array<any> = [
    { text: 'Personal details', activeState: hasCompletePrimaryContactDetails },
    { text: 'Company details', activeState: hasCompleteCompanyDetails },
    { text: 'Director details', activeState: hasCompleteContactsDetails },
    { text: 'Product selection', activeState: hasCompleteProductSelection },
    {
      text: 'Verification OR transactional data',
      activeState: hasCompleteVerification,
    },
  ];

  return (
    <>
      <Box display="flex" flexDirection="column" width="100%">
        <Box display="flex" mb={1} mt={0}>
          <Box display="flex" width={0.7}>
            <Typography variant="caption">Application stage</Typography>
          </Box>
          <Box display="flex" ml={8} width={0.3}>
            <Typography variant="caption">State</Typography>
          </Box>
        </Box>
        <Box display="flex" flexDirection="column">
          {properties.map((item: any, iItem: number) => (
            <Box
              key={`${id}-${item?.text}`}
              display="flex"
              flexDirection="column"
            >
              {!!iItem && (
                <Box ml={-1} width={1}>
                  <Divider />
                </Box>
              )}
              <Box alignItems="center" display="flex" my={1.8}>
                <Box display="flex" width={0.7}>
                  <Typography className="labelValue" variant="body1">
                    {item?.text}
                  </Typography>
                </Box>
                <Box display="flex" ml={8} width={0.3}>
                  <StatusInfo
                    showIcon
                    isCompleted={!!item?.activeState}
                    text={item?.activeState ? 'Complete' : 'Incomplete'}
                  />
                </Box>
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </>
  );
}
